import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Intervention from "./components/Intervention";
import Signes from "./components/Signes";
import Marques from "./components/Marques";
import Maillage from "./components/Maillage";
import Formulaire from "./components/Formulaire";
import Avis from "@/components/feature/Avis";
import DiagnosticVideo from "@/components/feature/DiagnosticVideo";
import Footer from "./components/Footer";
import FloatingButton from "./components/FloatingButton";

export default function TelecommandeVoletRoulantPage() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Télécommande Volet Roulant Strasbourg | Programmation"
        description="Remplacement et programmation de télécommande de volet roulant à Strasbourg et dans le Bas-Rhin. Toutes marques, devis gratuit. 03 74 47 32 40."
        path="/telecommande-volet-roulant"
        type="service"
        serviceType="Programmation et remplacement de télécommande de volet roulant"
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Télécommande" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Télécommande" }]} />
      <main>
        <Hero />
        <DiagnosticVideo />
        <Intervention />
        <Signes />
        <Marques />
        <Maillage />
        <Formulaire />
        <Avis />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}